import store from "@/store/index";
import { post } from "@/plugins/axios";

/*
 * 认证培训机构信息修改更新
 * @constructor jack
 * */

export const updateOrgCr2 = (
  org_name,
  org_code,
  org_license,
  username,
  zhiwu,
  phone,
  email,
  region_text,
  address,
  longitude,
  latitude,
  way,
  shengyuan,
  shizi,
  kecheng,
  kecheng_file,
  zhaosheng,
  renshu,
  zhaosheng_file,
  remark,
  shen_type,
  february_num,
  june_num,
  september_num,
  sum,
  u_token = store.state.token2
) => post("/org/updateOrgCr2", {
  org_name,
  org_code,
  org_license,
  username,
  zhiwu,
  phone,
  email,
  region_text,
  address,
  longitude,
  latitude,
  way,
  shengyuan,
  shizi,
  kecheng,
  kecheng_file,
  zhaosheng,
  renshu,
  zhaosheng_file,
  remark,
  shen_type,
  february_num,
  june_num,
  september_num,
  sum,
  u_token
});
